/**
 * 测试容器
 * @autor mll
 * @date 2019-09-05
 */
import Dynamic from './dynamic';
import { UserManagement } from './userManagementDemo';
import { ListSelect } from './list';
import RecordLog from './recordLog';
import TemplateDemo from './wizLayoutTemplate'
import Template from './template'
import TableList from './tableList'
import AddSection from './addSection'
import ShowSubject from './showSubject'
import BrowserExport from './browserExport'
import Upload from './upload'
import Charts from './charts'
import Steps from './steps'
import Anchor from './anchor'
import ExamPreview from './ExamPreview'
import QuestionPreview from './questionPreview'
import QuestionResult from './questionResult'
import TreeSelectList from './treeSelectList'
import Questionnair from './questionnair'
import ExamPercent from './examPercent'
import FormLinks from './formLinks'
import Iframe from './iframe'
import DataAuthSelect from './dataAuthSelect'
import OssUpload from './ossUpload'
import VideoGetPicDemo from './videoGetPicDemo'
import Cropper from './cropper'
import WizLocationSelectDemo from './wizLocationSelectDemo'
import WizCalendarDemo from './wizCalendarDemo'
import WizAuthorityDemo from './authority'
import PositionRadarDemo from './positionRadar'
import EditeorDemo from './editor'
import Copy from './copy'
import Image from './image'
import TableToExcel from "./tableToExcel";
import StuTabs from './stuTabs'
import HighSetDemo from './highSet/index'
export {
    Dynamic,
    UserManagement,
    RecordLog,
    TemplateDemo,
    Template,
    TableList,
    ListSelect,
    AddSection,
    ShowSubject,
    BrowserExport,
    Upload,
    VideoGetPicDemo,
    Charts,
    Steps,
    Anchor,
    ExamPreview,
    QuestionPreview,
    QuestionResult,
    TreeSelectList,
    Questionnair,
    ExamPercent,
    FormLinks,
    Iframe,
    DataAuthSelect,
    OssUpload,
    Cropper,
    WizLocationSelectDemo,
    WizCalendarDemo,
    WizAuthorityDemo,
    PositionRadarDemo,
    EditeorDemo,
    Copy,
    Image,
    TableToExcel,
    StuTabs,
  HighSetDemo,
}
